(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const animBusy = U.animBusy;
  const artStyle = U.artStyle;
  const backSvg = U.backSvg;
  const beginDrag = U.beginDrag;
  const cardActions = U.cardActions;
  const cardTitle = U.cardTitle;
  const clickCard = U.clickCard;
  const closeInspector = U.closeInspector;
  const dispatch = U.dispatch;
  const el = U.el;
  const esc = U.esc;
  const groupMoveDests = U.groupMoveDests;
  const live = U.live;
  const markStates = U.markStates;
  const pcls = U.pcls;
  const poolToken = U.poolToken;
  const renderHandCard = U.renderHandCard;
  const setShowLog = U.setShowLog;
  const togglePick = U.togglePick;
  const viewPlayer = U.viewPlayer;

  function pileActivations(state, ids) {
    const out = [];
    for (const iid of ids) {
      for (const a of cardActions(state, iid)) {
        if (!a.disabled) out.push({ iid: iid, action: a });
      }
    }
    return out;
  }

  function flashCard(iid, on) {
    const nodes = document.querySelectorAll("[data-iid='" + iid + "']");
    for (let i = 0; i < nodes.length; i++) nodes[i].classList.toggle("groupfocus", on);
  }

  function groupSprite(state, iid, ord, bad) {
    const sp = el("div", "gtsprite" + (bad ? " bad" : ""));
    artStyle(sp, state, iid, "full", 100);
    sp.appendChild(el("span", "gtord", String(ord)));
    sp.appendChild(el("span", "gtdrop", "✕"));
    sp.title = bad
      ? Core.name(state, iid) + " shares no destination with the rest — click to drop it."
      : "Drop " + Core.name(state, iid) + " from the group";
    sp.onclick = function (ev) { ev.stopPropagation(); flashCard(iid, false); U.toggleGroup(iid); };
    sp.onmouseenter = function () { flashCard(iid, true); };
    sp.onmouseleave = function () { flashCard(iid, false); };
    return sp;
  }

  const ENERGY_GLYPH = "<svg width='11' height='11' viewBox='0 0 16 16' fill='#ffd66b'><path d='M9 1L3 9h4l-1 6 7-9H8z'></path></svg>";

  function payActsText(acts) {
    const counts = { exhaustRune: 0, recycleRune: 0, legend: 0 };
    for (const act of acts || []) if (counts[act.mode] !== undefined) counts[act.mode]++;
    const parts = [];
    if (counts.exhaustRune) parts.push("exhaust " + counts.exhaustRune + " rune" + (counts.exhaustRune > 1 ? "s" : ""));
    if (counts.recycleRune) parts.push("recycle " + counts.recycleRune + " rune" + (counts.recycleRune > 1 ? "s" : ""));
    if (counts.legend) parts.push("use your legend");
    if (!parts.length) return null;
    const last = parts.pop();
    return parts.length ? parts.join(", ") + " and " + last : last;
  }

  function paySlots(pool, cost) {
    const power = {};
    for (const d in pool.power) power[d] = pool.power[d];
    let energy = pool.energy;
    const takeFirst = function (kinds) {
      for (const k of kinds) if (power[k] > 0) { power[k]--; return k; }
      return null;
    };
    const out = [];
    for (let i = 0; i < (cost.energy || 0); i++) {
      const ok = energy > 0;
      if (ok) energy--;
      out.push({ energy: true, doms: null, paid: ok ? "energy" : null });
    }
    let open = cost.anyPower || 0;
    for (const pip of cost.pips || []) {
      if (pip && pip.length) out.push({ energy: false, doms: pip, paid: takeFirst(pip.concat(["any"])) });
      else open++;
    }
    for (let i = 0; i < open; i++) {
      out.push({ energy: false, doms: null, paid: takeFirst(["any"].concat(Core.DOMAINS)) });
    }
    return out;
  }

  function slotChips(slots) {
    const wrap = el("div", "paychips");
    if (!slots.length) {
      wrap.appendChild(el("span", "zlabel", "Free"));
      return wrap;
    }
    for (const slot of slots) {
      const want = slot.energy ? "energy" : slot.doms ? slot.doms[0] : "any";
      const chip = el("span", "chip res " + want + (slot.paid ? " filled" : " unfilled"));
      if (slot.energy) {
        chip.appendChild(el("span", "slotglyph", ENERGY_GLYPH));
        chip.appendChild(el("span", null, "energy"));
        chip.title = slot.paid ? "Covered by 1 energy." : "1 energy. Exhaust a rune for 1 energy.";
      } else {
        chip.appendChild(poolToken(slot.paid || want, false, ""));
        chip.appendChild(el("span", null, slot.doms ? slot.doms.join(" / ") : "any"));
        chip.title = slot.paid
          ? "Covered by 1 " + (slot.paid === "any" ? "wildcard" : slot.paid) + " power."
          : slot.doms
            ? "1 power of " + slot.doms.join(" or ") + ". Recycle a matching rune for 1 power."
            : "1 power of any domain. Recycle a rune for 1 power.";
      }
      wrap.appendChild(chip);
    }
    return wrap;
  }

  const PAY_MODE_LABEL = { exhaustRune: "Exhaust", recycleRune: "Recycle", legend: "Add" };

  const PAY_MODE_GLYPH = { exhaustRune: ENERGY_GLYPH, recycleRune: "&#8635;", legend: "&#43;" };

  function payGainText(gain) {
    const gives = [];
    if (gain && gain.energy) gives.push(gain.energy + " energy");
    if (gain && gain.anyPower) gives.push(gain.anyPower + " wildcard power");
    if (gain && gain.domain) gives.push("1 " + (gain.domain === "any" ? "wildcard" : gain.domain) + " power");
    return gives.join(" + ");
  }

  function paySourceTile(state, pd, src, acts) {
    const iid = src.iid;
    const staged = acts.some(function (a) { return a.iid === iid; });
    const tile = el("div", "paysrc" + (src.kind === "legend" ? " legend" : "") +
      (src.kind === "rune" && !src.ready ? " spent" : "") + (staged ? " on" : ""));
    const art = el("div", "paysrcart");
    artStyle(art, state, iid, src.kind === "legend" ? "full" : "rune");
    art.title = cardTitle(state, iid);
    tile.appendChild(art);
    const foot = el("div", "paysrcfoot");
    if (src.kind === "rune") {
      foot.appendChild(poolToken(src.domain, false, ""));
      foot.appendChild(el("span", "paysrcdom", src.domain === "any" ? "any" : esc(src.domain)));
    } else {
      foot.appendChild(el("span", "paysrcdom", "legend"));
    }
    tile.appendChild(foot);
    const pills = el("div", "paysrcpills");
    for (const mode of U.payModes(state, pd, iid)) {
      const on = U.payStaged(acts, iid, mode);
      const gain = RB.Play.payActGain(state, pd.player, { iid: iid, mode: mode }, pd.payCtx || {});
      const pill = el("button", "paypill " + mode + (on ? " on" : ""),
        PAY_MODE_GLYPH[mode] + "<span class='pilltxt'>" + PAY_MODE_LABEL[mode] + "</span>");
      pill.title = (on ? "Staged, click to undo. " : "") + PAY_MODE_LABEL[mode] + " for " +
        (payGainText(gain) || "nothing") +
        (mode === "recycleRune" ? ". The rune returns to your rune deck." : ".");
      pill.onclick = function (ev) { ev.stopPropagation(); U.togglePayAct(iid, mode); };
      pills.appendChild(pill);
    }
    if (!pills.children.length) pills.appendChild(el("span", "zlabel", "Spent"));
    tile.appendChild(pills);
    tile.onmouseenter = function () { flashCard(iid, true); };
    tile.onmouseleave = function () { flashCard(iid, false); };
    return tile;
  }

  function renderAutoPaying(state, pd, plan) {
    const wrap = el("div", "payauto");
    wrap.appendChild(el("h3", null, esc(state.players[pd.player].name) + " — Paying"));
    const what = payActsText(plan);
    wrap.appendChild(el("span", "note", U.fmtText(
      (pd.note ? pd.note + " — " : "") + (what ? "auto-pay will " + what : "spending your floating pool") + ".")));
    return wrap;
  }

  function renderPay(state, pd) {
    const wrap = el("div", "paypanel");
    const actions = el("div", "payactions");
    const p = pd.player;
    const myPool = state.players[p].pool;
    const ctx = pd.payCtx || {};
    const manual = !!APP.manualPay;
    const acts = manual ? U.payActs() : [];
    const preview = RB.Play.poolAfterActs(state, p, acts, ctx);
    const slots = paySlots(preview, pd.cost);
    const covers = RB.Play.poolCovers(preview, pd.cost);
    const autoPlan = RB.Play.autoPayPlan(state, p, pd.cost, ctx);
    const autoText = autoPlan ? payActsText(autoPlan) : null;
    const staged = payActsText(acts);

    const head = el("div", "payhead");
    head.appendChild(el("h3", null, esc(state.players[p].name) + " — Pay"));
    if (pd.note) head.appendChild(el("span", "paywhat", U.fmtText(pd.note)));
    wrap.appendChild(head);

    const costRow = el("div", "payrow");
    costRow.appendChild(el("span", "paylabel", "Cost"));
    costRow.appendChild(slotChips(slots));
    wrap.appendChild(costRow);

    const poolRow = el("div", "payrow");
    poolRow.appendChild(el("span", "paylabel", "Pool"));
    const toks = U.poolTokens(state, p, 10);
    const poolBox = el("div", "paychips" + (toks.length ? "" : " empty"));
    if (toks.length) for (const t of toks) poolBox.appendChild(t);
    else poolBox.appendChild(el("span", "zlabel", "Empty"));
    poolRow.appendChild(poolBox);
    wrap.appendChild(poolRow);

    if (manual) {
      const srcs = RB.Play.payActSources(state, p, ctx);
      if (srcs.length) {
        const srcRow = el("div", "payrow sources");
        srcRow.appendChild(el("span", "paylabel", "Sources"));
        const tray = el("div", "paysrcs");
        for (const src of srcs) tray.appendChild(paySourceTile(state, pd, src, acts));
        srcRow.appendChild(tray);
        wrap.appendChild(srcRow);
      }
    }

    const status = el("div", "paystatus " + (covers ? "ok" : autoPlan ? "warn" : "bad"));
    status.appendChild(el("span", "paydot", ""));
    status.appendChild(el("span", null, manual
      ? covers
        ? staged ? "Ready — paying will " + staged + "." : "Your floating pool covers this."
        : autoPlan
          ? "Still short. Click a rune here or on the board, or auto-fill" +
            (autoText ? " to " + autoText : "") + "."
          : "Your runes cannot cover this cost."
      : covers
        ? "Your floating pool covers this."
        : autoPlan
          ? "Auto-pay will " + autoText + "."
          : "Auto-pay cannot cover this cost - pay it by hand or cancel."));
    wrap.appendChild(status);

    if (myPool.r && !RB.Play.restrictedUsable(myPool, ctx)) {
      wrap.appendChild(el("span", "note", "Your \"" +
        (myPool.r.tag === "spell" ? "spells only" : myPool.r.tag + " only") +
        "\" floating power cannot pay for this."));
    }

    const pay = el("button", "btn primary", acts.length ? "Pay" : "Pay from pool");
    if (covers) {
      pay.title = staged ? "Pay and " + staged + "." : "Spend your floating pool.";
      pay.onclick = function () {
        dispatch({ type: "PAY", player: p, activations: RB.Play.orderPayActs(acts) });
      };
    } else {
      pay.disabled = true;
      pay.title = "This does not cover the cost yet.";
    }
    actions.appendChild(pay);

    if (manual) {
      const fill = el("button", "btn", "Auto-fill");
      if (autoPlan && !covers) {
        fill.title = autoText ? "Stage the engine's own plan: " + autoText + "." : "Stage the engine's own plan.";
        fill.onclick = function () { U.setPayActs(RB.Play.orderPayActs(autoPlan)); };
      } else {
        fill.disabled = true;
        fill.title = covers ? "The cost is already covered." : "No set of activations covers this cost.";
      }
      actions.appendChild(fill);
      if (acts.length) {
        const clear = el("button", "btn", "Clear");
        clear.title = "Unstage every activation.";
        clear.onclick = function () { U.setPayActs([]); };
        actions.appendChild(clear);
      }
    } else {
      const auto = el("button", "btn", "Auto-pay");
      if (autoPlan) {
        auto.title = autoText ? "Auto-pay will " + autoText + "." : "Spend your floating pool.";
        auto.onclick = function () { dispatch({ type: "PAY", player: p, auto: true }); };
      } else {
        auto.disabled = true;
        auto.title = "No set of activations covers this cost.";
      }
      actions.appendChild(auto);
    }

    if (pd.cancellable) {
      const cancel = el("button", "btn danger", "Cancel");
      cancel.onclick = function () { dispatch({ type: "CANCEL", player: pd.player }); };
      actions.appendChild(cancel);
    }

    const mode = el("button", "btn ghost", manual ? "Pay automatically" : "Choose manually");
    mode.title = manual
      ? "Go back to paying costs automatically. Also on your rune deck."
      : "Open the sources tray and pick the runes yourself. Also on your rune deck.";
    mode.onclick = function () { U.setManualPay(!manual); };
    actions.appendChild(mode);

    wrap.appendChild(actions);
    return wrap;
  }

  Object.assign(U, { renderPay: renderPay, renderAutoPaying: renderAutoPaying, pileActivations: pileActivations, groupSprite: groupSprite });
})();
